import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/404.png'


const _hoisted_1 = {
  key: 0,
  class: "timeline-container"
}
const _hoisted_2 = { class: "lineleft" }
const _hoisted_3 = { class: "entry-list" }
const _hoisted_4 = { class: "infor-list" }
const _hoisted_5 = { class: "flow-header" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "user" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "nickname" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "content post-content" }
const _hoisted_14 = { class: "light_feedback" }
const _hoisted_15 = { class: "light_feedback_content" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "light_feedback_content_total"
}
const _hoisted_18 = { class: "sidebar-container" }
const _hoisted_19 = {
  key: 1,
  class: "empty-list"
}

import { onMounted, reactive, toRefs, markRaw, ref } from "vue";
import MainHeader from "@/components/main-header.vue";
import UserItem from "@/components/User-Item.vue";

import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import axiosInstance from "@/utils/axiosInstance";

import { Viewer } from "@bytemd/vue-next";

import gfm from "@bytemd/plugin-gfm";
import "bytemd/dist/index.css";

// 突出显示代码块
import highlight from "@bytemd/plugin-highlight";
import "highlight.js/styles/default.css";

// 对齐方式
import alignPlugin from "bytemd-plugin-align";
// 主题
import theme from "bytemd-plugin-theme";
// 解析前言 格式化
import frontmatter from "@bytemd/plugin-frontmatter";
// 表情
import gemoji from "@bytemd/plugin-gemoji";

// 代码高亮
import highLightPlugin from "bytemd-plugin-highlight";
// 图片的缩放
import imagePlugin from "bytemd-plugin-image";
// 代码复制
import copyCode from "bytemd-plugin-copy-code";
import "bytemd-plugin-copy-code/dist/style/index.css";

// 缩放图片 点击图片放大,再点击缩小
import mediumZoom from "@bytemd/plugin-medium-zoom";
// 图表
import mermaid from "@bytemd/plugin-mermaid";
import mermaidLocale from "@bytemd/plugin-mermaid/locales/zh_Hans.json";
// 数学公式插件
import math from "@bytemd/plugin-math";
import mathLocale from "@bytemd/plugin-math/locales/zh_Hans.json";
import "katex/dist/katex.css";

import zhHans from "bytemd/locales/zh_Hans.json";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";

//用户信息 登陆相关
import { useUserInfoStore } from "@/stores/userInfo";
import { useOAuthStore } from "@/stores/oauth";
import { useUIStore } from "@/stores/loginDialog";
interface ArticleLikers{
  likers_id:string;
  article_id:string;
  user_id:string;
  nickname:string;
  full_avatar_url:string;
  is_creator:boolean
}
//文章信息

export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleDetail',
  setup(__props) {

const oauthStore = useOAuthStore();
const uiStore = useUIStore();
const userStore = useUserInfoStore();

const SSRData = ref({
  title: "",
  description: "",
  keywords:
    "宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

// 插件
const pluginsList = [
  gfm(),
  math({
    locale: mathLocale,
  }),
  alignPlugin(),
  highLightPlugin(),
  imagePlugin(),
  copyCode({
    copySuccess: (text) => {
      console.log(text);
      ElMessage.success("代码复制成功");
    },
    copyError: (err) => {
      console.log(err);
    },
  }),
  mediumZoom(),
  mermaid({
    locale: mermaidLocale,
  }),
  highlight(),
  theme(),
  frontmatter(),
  gemoji(),
];

const router = useRouter();

// 编辑器数据初始化
const state = reactive({
  value: "",
  plugins: markRaw(pluginsList),
  zh: zhHans,
  isempty: ref(true),
});

const { value, plugins, zh, markDownRef } = toRefs(state);

const DetailInfo = reactive({
  article_id: "",
  title: "",
  info_content: "",
  category_id: "",
  category_name: "",
  brief_content: "",
  link_url: "",
  cover_image: "",
  comment_count: "",
  view_count: "",
  digg_count: "",
  favorited_count: "",
  is_markdown: "",
  is_hot: "",
  uuid: "",
  author: "",
  created_at: "",
  avatar_url: "",
  has_liked:false,
  likers:ref<ArticleLikers[]>([])
});

onMounted(async () => {
  //获取文章ID 参数
  const postID = router.currentRoute.value.params.postID as string;
  fetchArticleInfoData(postID);
});

// 获取文章数据
const fetchArticleInfoData = async (postID: string) => {
  try {
    await axiosInstance
      .get("/api/HomeArticle/detail", {
        params: { article_id: postID },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          const articleData = result.data;
          DetailInfo.article_id = articleData.article_id;
          DetailInfo.title = articleData.title;
          DetailInfo.info_content = articleData.info_content;
          DetailInfo.category_id = articleData.category_id;
          DetailInfo.category_name = articleData.category_name;
          DetailInfo.brief_content = articleData.brief_content;
          DetailInfo.link_url = articleData.link_url;
          DetailInfo.cover_image = articleData.cover_image;
          DetailInfo.comment_count = articleData.comment_count;
          DetailInfo.view_count = articleData.view_count;
          DetailInfo.digg_count = articleData.digg_count;
          DetailInfo.favorited_count = articleData.favorited_count;
          DetailInfo.is_markdown = articleData.is_markdown;
          DetailInfo.is_hot = articleData.is_hot;
          DetailInfo.uuid = articleData.uuid;
          DetailInfo.author = articleData.author;
          DetailInfo.avatar_url = articleData.avatar_url;
          DetailInfo.created_at = articleData.created_at;
          state.value = articleData.info_content;
          DetailInfo.has_liked = articleData.has_liked;
          DetailInfo.likers = articleData.likers;
          //SEO 内容
          SSRData.value.title = articleData.title + " - " + WebSite_Name;
          SSRData.value.description = articleData.brief_content;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = "找不到页面";
          SSRData.value.description = "";
          SSRData.value.keywords = "";
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取文章数据失败");
  }
};

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};

// 处理有启发功能
const handleLike = async () => {
  if (!oauthStore.token) {
      uiStore.showLoginDialog();
  }

  try {
    // 构造点赞用户信息
    const liker = {
      likers_id: "", // 后端生成
      article_id: DetailInfo.article_id,
      user_id: userStore.user.uuid,
      nickname: userStore.user.uname,
      full_avatar_url: userStore.user.avatar_url,
      is_creator: false
    };
    var postData = {
      like:'like',
      article_id:DetailInfo.article_id
    }
    // 调用API插入数据
    await axiosInstance.post("/api/ArticleLikers/HasLike", postData);
    
    // 更新前端状态
    DetailInfo.likers.push(liker);
    DetailInfo.has_liked = true;
  } catch (error) {
    console.error("点赞操作失败:", error);
  }
};

// 处理取消已启发功能
const handleUnlike = async () => {
  try {
    var postData = {
      like:'unlike',
      article_id:DetailInfo.article_id
    }
    // 调用API删除数据
    await axiosInstance.post("/api/ArticleLikers/HasLike",postData);
    
    // 更新前端状态
    const index = DetailInfo.likers.findIndex(
      liker => liker.user_id === userStore.user.uuid
    );
    
    if (index !== -1) {
      DetailInfo.likers.splice(index, 1);
    }
    DetailInfo.has_liked = false;
  } catch (error) {
    console.error("取消点赞操作失败:", error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    (state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      href: `/user/${DetailInfo.uuid}`,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: DetailInfo.avatar_url,
                          class: "avatar"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(DetailInfo.author), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(DetailInfo.created_at) + " 创建", 1)
                        ])
                      ])
                    ], 8, _hoisted_6)
                  ]),
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(DetailInfo.title), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(Viewer), {
                      ref_key: "markDownRef",
                      ref: markDownRef,
                      locale: _unref(zh),
                      value: _unref(value),
                      plugins: _unref(plugins)
                    }, null, 8, ["locale", "value", "plugins"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (!DetailInfo.has_liked)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "light_feedback_action unlike",
                          onClick: handleLike
                        }, _cache[0] || (_cache[0] = [
                          _createElementVNode("svg", {
                            t: "1749967214557",
                            class: "icon",
                            viewBox: "0 0 1024 1024",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "p-id": "10276",
                            width: "20",
                            height: "20"
                          }, [
                            _createElementVNode("path", {
                              d: "M512 0C296.421053 0 121.263158 175.157895 121.263158 390.736842c0 148.210526 80.842105 274.863158 202.105263 342.231579v140.126316c0 29.642105 24.252632 53.894737 53.894737 53.894737h269.473684c29.642105 0 53.894737-24.252632 53.894737-53.894737v-140.126316c121.263158-67.368421 202.105263-194.021053 202.105263-342.231579C902.736842 175.157895 727.578947 0 512 0z m134.736842 870.4H377.263158v-53.894737h269.473684v53.894737z m26.947369-185.936842l-26.947369 16.168421v56.589474H377.263158V700.631579l-26.947369-16.168421c-51.2-29.642105-97.010526-70.063158-126.652631-121.263158-32.336842-51.2-48.505263-113.178947-48.505263-175.157895 0-45.810526 8.084211-88.926316 26.947368-132.042105 16.168421-40.421053 40.421053-75.452632 72.757895-107.789474s67.368421-56.589474 107.789474-72.757894c40.421053-18.863158 86.231579-26.947368 132.042105-26.947369s88.926316 8.084211 132.042105 26.947369c40.421053 16.168421 75.452632 40.421053 107.789474 72.757894 29.642105 29.642105 56.589474 67.368421 72.757895 107.789474 18.863158 40.421053 26.947368 86.231579 26.947368 132.042105 0 61.978947-16.168421 121.263158-48.505263 175.157895-35.031579 51.2-80.842105 94.315789-132.042105 121.263158z m-56.589474 280.252631h-207.494737c-13.473684 0-26.947368 10.778947-26.947368 26.947369v5.389474c0 13.473684 10.778947 26.947368 26.947368 26.947368h207.494737c13.473684 0 26.947368-10.778947 26.947368-26.947368v-8.084211c0-13.473684-13.473684-24.252632-26.947368-24.252632z",
                              fill: "#ffd679",
                              "p-id": "10277",
                              "data-spm-anchor-id": "a313x.search_index.0.i3.5b953a81D8Jkou",
                              class: ""
                            }),
                            _createElementVNode("path", {
                              d: "M657.515789 369.178947h-83.536842c-8.084211 0-13.473684-8.084211-13.473684-13.473684l29.642105-183.242105c2.694737-13.473684-10.778947-21.557895-21.557894-10.778947l-212.884211 226.357894c-8.084211 8.084211-2.694737 21.557895 8.084211 21.557895h83.536842c8.084211 0 13.473684 8.084211 13.473684 13.473684L431.157895 606.315789c-2.694737 10.778947 13.473684 18.863158 21.557894 10.778948l212.884211-226.357895c8.084211-8.084211 2.694737-21.557895-8.084211-21.557895z",
                              fill: "#ffd679",
                              "p-id": "10278",
                              "data-spm-anchor-id": "a313x.search_index.0.i2.5b953a81D8Jkou",
                              class: ""
                            })
                          ], -1),
                          _createTextVNode(" 有启发 ")
                        ])))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "light_feedback_action like",
                          onClick: handleUnlike
                        }, _cache[1] || (_cache[1] = [
                          _createElementVNode("svg", {
                            t: "1750033311118",
                            class: "icon",
                            viewBox: "0 0 1041 1024",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "p-id": "21531",
                            width: "24",
                            height: "24"
                          }, [
                            _createElementVNode("path", {
                              d: "M276.592 276.464c10.48 0 20.96-10.416 20.96-20.848 0-10.4-10.48-24.304-20.96-24.304s-24.448 10.416-24.448 20.832c3.488 13.904 10.48 24.32 24.448 24.32z m69.84-166.704c6.976 6.944 10.48 13.888 10.48 24.32 0 10.4-3.504 17.36-3.504 27.776s0 17.36 10.48 20.832c6.992 3.472 13.968 0 20.96-6.944l20.96-20.832c6.976-6.944 13.968-10.416 20.944-6.944 10.48 0 20.96 3.472 31.424 3.472 6.992 0 13.968-3.472 17.472-10.416 3.488-6.96 3.488-13.888-3.504-20.848-6.976-6.944-13.968-10.4-20.96-17.36-6.976-6.944-13.952-13.888-10.464-24.32 0-6.928 3.488-17.36 3.488-24.288 0-10.432 0-17.376-10.464-20.848-10.48-3.472-17.472 0-20.96 6.944-6.976 6.944-10.48 13.904-17.456 17.376-6.992 10.4-13.968 13.888-27.936 10.4-10.48-6.944-20.96-6.944-27.952-6.944-10.464 0-17.44 3.472-20.96 10.432-3.472 6.944 0 13.888 7.008 20.832 6.976 6.944 13.952 10.416 20.96 17.36z m-59.36 229.216c6.976 20.832 13.968 38.192 20.96 59.04 6.976 13.888 17.44 20.832 27.92 13.888 10.48-3.472 17.456-17.376 13.968-31.264-6.976-20.832-13.968-38.192-20.96-59.04-3.472-10.4-10.464-13.888-20.944-13.888-13.968 3.472-24.448 17.36-20.96 31.264z m719.376 270.88c-3.488-6.944-10.48-10.432-17.456-10.432H961.04c-10.464 0-17.44-3.472-24.432-10.4-3.488-6.96-10.48-13.904-13.968-20.848-6.992-6.944-13.968-13.888-20.96-10.416-10.48 3.472-10.48 10.416-10.48 20.832v24.32c0 10.4-3.488 17.36-10.464 24.304-6.992 3.472-13.984 10.416-20.96 13.888-6.976 6.944-13.968 13.888-10.48 24.32 3.504 10.4 10.48 10.4 20.96 10.4h24.448c10.464 0 17.456 3.488 24.448 10.432 6.976 6.944 10.464 13.888 17.44 24.32 3.504 6.928 10.48 6.928 20.96 6.928 6.992-3.472 13.968-6.944 13.968-17.36V668.88c0-10.4 3.504-13.888 10.48-20.832 6.992-6.944 17.456-10.4 24.448-17.36 0-6.944 3.488-13.888 0-20.832zM381.36 786.976l10.464-128.512 90.8 90.304-101.28 38.192z m-55.872 24.288l-62.88 27.792 20.96-281.296v-6.944l59.36 59.04-17.44 201.408zM206.752 863.36l-69.856 27.792 80.32-191.008-10.464 163.216z m87.296-402.832c-6.976-6.96-20.96-10.432-31.424-10.432-10.48 3.472-20.96 10.432-27.936 20.848L35.648 943.232c-6.992 13.904-3.52 27.792 6.96 38.208 10.48 10.416 24.448 13.888 38.416 6.944l478.432-197.952c10.48-3.472 17.456-13.888 20.96-27.776 3.488-10.416 0-24.32-10.48-31.248l-275.888-270.88z m412.08 236.144c-6.992-3.472-17.472-6.944-24.448-10.416-13.968-3.472-24.448-10.416-38.4-13.888-13.984-3.488-24.464 3.472-27.952 13.888-3.488 13.888 0 24.32 13.968 27.776l62.864 20.832c13.968 3.472 27.936-6.944 27.936-17.36 0-10.4-3.488-17.36-13.968-20.832z m118.72-131.968c-118.72-48.624-199.04-20.832-286.352 41.68-13.968 6.944-13.968 24.304-6.976 38.192 6.976 6.944 13.968 10.416 20.96 10.416 6.976 0 10.464 0 13.952-3.472 76.832-55.568 136.192-76.4 233.984-34.72 13.968 6.944 31.424 0 34.912-13.888 10.48-17.376 3.504-34.72-10.464-38.208zM782.944 727.92c-10.464 0-24.448 10.416-24.448 20.848 0 10.4 10.48 20.832 20.96 24.304 10.48 0 24.448-10.416 24.448-20.832 0-13.904-10.48-24.32-20.96-24.32z m90.8-350.752c-13.968 0-24.448 10.432-24.448 20.848 0 13.888 10.48 20.832 20.96 20.832 13.968 0 24.448-10.416 20.96-24.32 3.488-6.928-6.992-17.36-17.472-17.36z m-436.512-177.12c-13.968 6.96-20.96 20.848-13.968 34.736 38.4 97.248 20.96 156.272-34.928 232.688-6.976 13.888-6.976 27.776 6.992 38.192 3.488 3.472 10.48 3.472 13.968 3.472 6.976 0 17.44-3.472 20.96-10.416 62.848-86.816 90.784-166.688 41.888-284.768-3.488-13.888-20.96-20.848-34.912-13.888zM741.04 245.2c6.992 3.472 17.456 3.472 24.448 6.944 10.48 3.472 13.968 6.96 17.456 17.376 3.504 10.4 3.504 17.36 6.992 27.776 3.488 6.944 6.976 13.888 17.456 13.888 6.992 0 13.968-6.944 17.472-13.888 3.488-10.416 6.976-17.36 6.976-27.776 3.488-10.416 6.992-13.904 17.456-17.376 10.48-3.472 20.96-6.944 27.936-10.4 6.992-3.488 10.48-10.432 13.968-17.376 0-10.416-6.976-13.888-13.968-17.36-6.976 0-17.44-3.472-24.432-6.944-10.48-3.472-17.472-6.96-17.472-17.376-3.488-6.944-3.488-17.36-6.976-24.32-3.488-10.4-6.992-13.872-17.472-13.872-10.464 0-13.968 6.944-17.456 13.888-3.488 6.944-3.488 13.888-6.976 24.32-6.992 10.4-13.968 17.36-24.448 17.36-6.976 3.472-13.968 3.472-20.96 6.944-10.464 3.472-17.456 6.944-17.456 17.36 0 13.888 6.992 17.36 17.456 20.832z m48.896 166.704c-31.44 10.416-59.36 24.32-87.312 38.192-6.976 3.472-13.968 10.432-13.968 20.848 0 13.888 13.968 24.32 27.952 17.36 31.424-10.416 59.36-24.32 90.784-38.208 13.968-6.944 17.472-17.36 10.48-27.776-3.488-10.416-13.968-17.36-27.936-10.416z m-223.504-62.512c10.48 0 17.472-3.472 20.96-10.416 13.968-31.264 27.936-62.512 38.4-93.76 3.504-10.432 0-20.848-10.464-27.792-10.48-3.472-24.448 0-27.936 10.4-13.968 31.28-27.936 62.528-38.4 93.776-7.008 13.888 3.488 27.792 17.44 27.792z m-101.28 184.064c-6.976 17.36 3.504 34.72 24.464 38.192 10.464 0 17.44-3.472 20.96-6.944 27.92-27.792 55.856-55.568 80.304-83.36l132.704-131.952c6.992-6.944 10.48-10.416 10.48-20.832 0-13.904-6.992-24.32-20.96-27.792-13.968-3.472-20.96 0-27.936 6.944-101.28 100.72-111.744 114.608-213.024 215.312-3.488 3.472-6.976 6.96-6.976 10.432zM636.304 186.16c13.952 0 24.432-10.4 24.432-24.304 0-10.416-10.48-20.832-20.96-20.832-13.952 0-24.432 10.4-24.432 24.32 0 10.4 6.992 20.816 20.96 20.816z",
                              fill: "#FF4400",
                              "p-id": "21532"
                            })
                          ], -1),
                          _createTextVNode(" 已反馈 ")
                        ]))),
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((DetailInfo.likers || []).slice(0, 7), (liker) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: liker.likers_id,
                          class: "avatar",
                          src: liker.full_avatar_url
                        }, null, 8, _hoisted_16))
                      }), 128)),
                      (DetailInfo.likers.length>7)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(DetailInfo.likers.length), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(UserItem, {
                "user-id": DetailInfo.uuid
              }, null, 8, ["user-id"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "null-infor-list" }, [
            _createElementVNode("div", { class: "content-flag" }, [
              _createElementVNode("div", { class: "common-empty" }, [
                _createElementVNode("img", { src: _imports_0 })
              ])
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})